/**
 * Notification API Service — Web
 * Mirrors mobile notificationAPI.js, calls the proton-chat server notification endpoints.
 */
import axios from 'axios';
import { store } from '../application/store';

const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL || 'http://68.178.162.134:5001/api/v1';

const notificationClient = axios.create({
  baseURL: CHAT_API_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Inject chat token
notificationClient.interceptors.request.use((config) => {
  const state = store.getState();
  const chatToken = state.auth?.chatToken;
  if (chatToken) {
    config.headers.Authorization = `Bearer ${chatToken}`;
  }
  return config;
});

const notificationAPI = {
  /**
   * Fetch paginated notifications for a user
   * GET /notifications/user/:userId?page=&limit=&unread_only=
   */
  async getUserNotifications(userId, { page = 1, limit = 20, unread_only = false } = {}) {
    const params = { page, limit };
    if (unread_only) params.unread_only = 'true';
    const { data } = await notificationClient.get(`/notifications/user/${userId}`, { params });
    return data; // { success, data: { notifications, unread_count, pagination } }
  },

  /**
   * Get unread count
   * GET /notifications/user/:userId/unread-count
   */
  async getUnreadCount(userId) {
    const { data } = await notificationClient.get(`/notifications/user/${userId}/unread-count`);
    return data; // { success, data: { unread_count } }
  },

  /**
   * Mark a single notification as read
   * PUT /notifications/:id/read
   */
  async markAsRead(notificationId) {
    const { data } = await notificationClient.put(`/notifications/${notificationId}/read`);
    return data;
  },

  /**
   * Mark all notifications as read
   * PUT /notifications/user/:userId/read-all
   */
  async markAllAsRead(userId) {
    const { data } = await notificationClient.put(`/notifications/user/${userId}/read-all`);
    return data;
  },

  /**
   * Delete a notification
   * DELETE /notifications/:id
   */
  async deleteNotification(notificationId) {
    const { data } = await notificationClient.delete(`/notifications/${notificationId}`);
    return data;
  },
};

export default notificationAPI;
